// src/contexts/ServicesContext.jsx

import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { db } from '../firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';

// Create a Context
const ServicesContext = createContext();

// Custom hook to use the ServicesContext
export const useServices = () => {
  return useContext(ServicesContext);
};

// ServicesProvider component - fetches the "services" collection once and
// shares it with every consumer, instead of each component fetching its own copy.
export const ServicesProvider = ({ children }) => {
  const [services, setServices] = useState([]);
  const [loadingServices, setLoadingServices] = useState(true);
  const [errorServices, setErrorServices] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchServices = async () => {
      try {
        const servicesCollection = collection(db, 'services');
        const servicesSnapshot = await getDocs(servicesCollection);
        const servicesList = servicesSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        if (!cancelled) {
          setServices(servicesList);
          setLoadingServices(false);
        }
      } catch (error) {
        console.error('Error fetching services: ', error);
        if (!cancelled) {
          setErrorServices('fetch_services_error');
          setLoadingServices(false);
        }
      }
    };

    fetchServices();

    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(
    () => ({ services, loadingServices, errorServices }),
    [services, loadingServices, errorServices]
  );

  return (
    <ServicesContext.Provider value={value}>
      {children}
    </ServicesContext.Provider>
  );
};
